import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';

export const requiredTrueValidator = (message: string): ValidatorFn => (control: AbstractControl): ValidationErrors | null => {
    const validationErrors = Validators.requiredTrue(control);
    if (validationErrors) {
        return {
            requiredTrue: message
        };
    }
    return null;
};
